export const ALWAYSSHOWBUTTONS = 'alwaysShowButtons';
export const SAFEROLLOUTACTIVE = 'safeRolloutActive';